import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormField } from '../../../../../../../global/form/form-field/form-field';

export type ConnectionTypeFieldProps = {
    value: string;
};

export const ConnectionTypeField = (props: ConnectionTypeFieldProps): JSX.Element => {
    return (
        <FormField
            className='m-bottom-20px'
            label={<FormattedMessage id='oe.connection.connectionType' description='label' defaultMessage='Connection Type' />}
        >
            <input
                className='oe-form-field__control'
                value={props.value}
                type='text'
                disabled={true}
            />
        </FormField>
    );
};
